module.exports = "https://static-production.npmjs.com/338e4905a2684ca96e08c7780fc68412.png";